import { getPostRequestFetchOptions } from "../legacyClients";

interface RegisterBody {
  confirmEmail: string;
  displayName: string;
  email: string;
  subscribeToNewsletter: boolean;
  userName: string;
  password: string;
  confirmPassword: string;
}

interface AlmostThereBody {
  userName: string;
  displayName: string;
  token: string;
  subscribeToNewsletter: boolean;
}

type AlmostThere = (
  route: {},
  body: AlmostThereBody
) => Promise<
  | { returnUrl: string }
  | {
      key: string;
      error: string;
    }[]
>;

type RegisterUser = (
  route: {},
  body: RegisterBody
) => Promise<{
  status: string;
  message: string | null;
}>;

type ValidateUsername = (
  route: {},
  body: { username: string }
) => Promise<{ message?: string }>;

export interface AccountsClient {
  registerUser: RegisterUser;
  almostThere: AlmostThere;
  validateUsername: ValidateUsername;
}

export const accountsClient: AccountsClient = {
  // message is "undefined" when username validation is successful, else the error message
  validateUsername: async (_route, body) => {
    const fetchOptions = await getPostRequestFetchOptions();
    const response = await fetch("/account/validate-username", {
      ...fetchOptions,
      body: JSON.stringify(body),
    });

    const { message } = await response.json();
    return {
      message,
    };
  },

  // message is "undefined" when user is successfully registered, else the error message
  registerUser: async (_route, body) => {
    const fetchOptions = await getPostRequestFetchOptions();
    const response = await fetch("/account/register", {
      ...fetchOptions,
      body: JSON.stringify(body),
    });

    return response.json();
  },

  // returnUrl is defined on request success
  almostThere: async (_route, body) => {
    const fetchOptions = await getPostRequestFetchOptions();
    const response = await fetch("/account/register/almost", {
      ...fetchOptions,
      body: JSON.stringify(body),
    });

    return response.json();
  },
};
